import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const expertise = ['Program & Project Management', 'IT Strategy & Operations', 'Digital & Business Transformation', 'Agile Program Execution', 'Operational Process Optimization', 'Risk & Compliance Management (ISO 9001)', 'Strategic Partnerships & Business Growth', 'Change Leadership (Prosci Certified)', 'Cross-Functional Team Leadership', 'Stakeholder & Executive Engagement'];
export function Expertise() {
  return <Section id="expertise" background="gray" data-id="element-112" data-mp="1dpwzg362yz2l">
      <FadeIn className="text-center mb-12" data-id="element-113" data-mp="1dp3oeq039nen">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-114" data-mp="1inyfef87mi9u">
          Core Expertise
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-115" data-mp="26dj135vqztmt">
          Comprehensive leadership capabilities spanning strategy, operations,
          and technical execution.
        </p>
      </FadeIn>

      <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-116" data-mp="hokwuznsj7e6">
        {expertise.map((item, index) => <StaggerItem key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 flex items-start hover:shadow-md transition-shadow duration-200" data-id="element-117" data-mp="crcaemvm0h74" data-mpi={index}>
            <CheckCircle2 className="w-6 h-6 text-[#1e3a8a] mr-4 flex-shrink-0 mt-0.5" data-id="element-118" data-mp="mmmgpmt1jaqp" />
            <span className="text-gray-800 font-medium" data-id="element-119" data-mp="10eaq3ibwnl3z">{item}</span>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
}